import { engineComponent, NumberUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { Symbols } from "../GameComponents/Symbols";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { BaseView } from "../GameComponents/Base/BaseView";
import { Paylines } from "../GameComponents/Paylines";
import { FreespinsView } from "../GameComponents/Freespins/FreespinsView";
import { Communication } from "neo-games";
import { Symbol } from "../GameComponents/Symbol";
import { Payline } from "../GameComponents/Payline";
import { ImageTextCounterElement } from "../Components/Elements/Texts/ImageTextCounterElement";
import { Tweens } from "../Components/Effects/Tweens";
import { BetManager } from "../Managers/BetManager";
import { PlayList } from "../Components/Sounds/PlayList";
import { AppContext } from "../../Common/AppContext";
import { WinType } from "neo-games/Engine/Communication/Game/Types/WinType";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { ReelExtended } from "./ReelExtended";
import { ModuleManager } from "../Managers/ModuleManager";
import { DataManager } from "../Managers/DataManager";
import { GameManager } from "../Managers/GameManager";
import { CustomUtils } from "../Utils/CustomUtils";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorExtended extends WinAnimator {
    private _paylines: Paylines;
    private _cycleAnimationName: string = "Value";
    private _paylineWinDelay: number = 45;
    private _paylineWinEndDelay: number = 80;

    private _activeElementsNames: Array<string> = [];
    private _activeElements: Array<SwitchElement> = [];
    private _activeElementsCase: string;

    public static readonly CaseNormal = "NORMAL";
    protected static readonly CaseWin = "WIN";
    protected static readonly CaseMiddleLineWin = "MIDDLE_LINE_WIN";
    protected static readonly CaseNoWin = "NOWIN";
    protected static readonly CaseHighWin = "HIGHWIN";
    public static readonly CaseTeasing = "TEASING";
    public static readonly CaseTeasingStop = "TEASING_STOP";

    // private _counterTimer: FrameTimerEventEmitter;
    private _currentWinIndex = 0;
    private _counter: ImageTextCounterElement;
    private _flare: ImageElement;
    private _doubleWin: SwitchElement;
    // private _counterFinished : boolean = false;
    private currentCounterStep: number;

    protected static readonly ShowFirstWinsStep = "showFirstWinsStep";
    protected static readonly EndFirstWinsStep = "endFirstWinsStep";
    protected static readonly FinishWin = "finishWin";

    private _bgElementName: string = "";
    private _bgWinsIndex: Array<number>;
    private _bgScaleX: number = 1;
    private _bgScaleXMul: number = 0;
    private _bgScaleXRankFrom: number = 0;
    private _bgScaleXRankTo: number = 0;

    constructor() {
        super();
        // this._counterTimer = CreateFrameTimer('_counterTimer');
        // this._counterTimer.on(FrameTimerEvents.Complete, this.counterWins.bind(this));
    }

    configure(node: Element): void {
        super.configure(node);

        if (node.hasAttribute(WinAnimatorExtendedAttributes.CYCLE_ANIMATION)) {
            this._cycleAnimationName = node.getAttribute(WinAnimatorExtendedAttributes.CYCLE_ANIMATION);
        }

        if (node.hasAttribute(WinAnimatorExtendedAttributes.ACTIVE_ELEMENTS)) {
            this._activeElementsNames = node.getAttribute(WinAnimatorExtendedAttributes.ACTIVE_ELEMENTS).split(";");
        }

        if (node.hasAttribute(WinAnimatorExtendedAttributes.BG_WINS_INDEX)) {
            let stringIndex = node.getAttribute(WinAnimatorExtendedAttributes.BG_WINS_INDEX);

            if (stringIndex != null) {
                this._bgWinsIndex = stringIndex.split(";").map((value) => parseInt(value));
            }
        }

        if (node.hasAttribute(WinAnimatorExtendedAttributes.BG_ELEMENT_NAME)) {
            this._bgElementName = node.getAttribute(WinAnimatorExtendedAttributes.BG_ELEMENT_NAME);
        }

        if (node.hasAttribute(WinAnimatorExtendedAttributes.BG_SCALE_X)) {
            this._bgScaleX = parseFloat(node.getAttribute(WinAnimatorExtendedAttributes.BG_SCALE_X));
        }

        if (node.hasAttribute(WinAnimatorExtendedAttributes.BG_SCALE_X_MULTIPLIER)) {
            this._bgScaleXMul = parseFloat(node.getAttribute(WinAnimatorExtendedAttributes.BG_SCALE_X_MULTIPLIER));
        }

        if (node.hasAttribute(WinAnimatorExtendedAttributes.BG_RANK_FROM)) {
            this._bgScaleXRankFrom = parseFloat(node.getAttribute(WinAnimatorExtendedAttributes.BG_RANK_FROM));
        }

        if (node.hasAttribute(WinAnimatorExtendedAttributes.BG_RANK_TO)) {
            this._bgScaleXRankTo = parseFloat(node.getAttribute(WinAnimatorExtendedAttributes.BG_RANK_TO));
        }
    }

    initialize(
        symbols: Symbols,
        paylines?: Paylines,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
        parent?: BaseView | FreespinsView,
    ): void {
        this._paylines = paylines;

        super.initialize(symbols, paylines, noWinSymbolsContainer, symbolsContainer);

        if (!this.value && this._cycleAnimationName && this.childs[this._cycleAnimationName]) {
            this.value = this.childs[this._cycleAnimationName];
            this.animationsContainer.addChild(this.value);
        }

        if (parent) {
            this._activeElementsNames.forEach((elementName) => {
                if (parent.childs[elementName] && parent.childs[elementName] instanceof SwitchElement) {
                    this._activeElements.push(parent.childs[elementName]);
                }
            });

            this._doubleWin = <SwitchElement>parent.getChildElementByName("DoubleWin");

            let middleground = <SwitchElement>parent.getChildElementByName("Middleground");
            let goldenLine = <SwitchElement>middleground.getChildElementByName("GoldenLine");
            let beamContainer = <ContainerElement>goldenLine.getChildElementByName("BeamContainer");
            let beam = <ImageElement>beamContainer.getChildElementByName("Beam");

            var addFilter = new PIXI.filters.VoidFilter();
            addFilter.blendMode = CustomUtils.getBlendMode(PIXI.BLEND_MODES.ADD);
            beam.filters = [addFilter];
        }

        if (this.childs["Flare"]) {
            this._flare = this.childs["Flare"];
            this.addChild(this._flare);
        }

        if (this.childs["Counter"]) {
            this._counter = this.childs["Counter"];
            this.addChild(this._counter);
        }
    }

    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    /**
     * Sorts symbols according to their zIndex attribute, if applicable
     */
    private sortSymbols(): void {
        if (!this.symbols.hasZindex) {
            return;
        }
        let addQueue: Symbol[] = [];
        this.symbolsContainer.children.forEach((symbol) => {
            addQueue.push(<Symbol>symbol);
        });
        addQueue.sort((a, b) => a.zIndex - b.zIndex);
        addQueue.forEach((symbol) => {
            this.addChild(symbol);
        });
    }

    showSymbols(reelsData: Array<Communication.Game.IReel>) {
        super.showSymbols(reelsData);
        this.sortSymbols();
    }

    // public symbolsGoToTeasing(reelIndex: number, isSecondChance: boolean): void {
    //     for (let i = 0; i < reelIndex; i++) {
    //         for (let j = 0; j < this.currentSymbols[i].length; j++) {
    //             const symbol = this.currentSymbols[i][j];
    //             if (symbol !== null) {
    //                 if(isSecondChance) {
    //                     if (this.allowSymbolGoToCase(i, j, Symbol.CaseNowin)) {
    //                         const currentCaseType = symbol.getCurrentCase();
    //
    //                         if (Symbol.CaseNowin !== currentCaseType) {
    //                             symbol.goToCase(Symbol.CaseNowin);
    //                         }
    //                     }
    //                 } else {
    //                     if (symbol.id !== Settings.SymbolTeasing-1 && this.allowSymbolGoToCase(i, j, Symbol.CaseNowin)) {
    //                         const currentCaseType = symbol.getCurrentCase();
    //
    //                         if (Symbol.CaseNowin !== currentCaseType) {
    //                             symbol.goToCase(Symbol.CaseNowin);
    //                         }
    //                     } else if(symbol.id === Settings.SymbolTeasing-1 && this.allowSymbolGoToCase(i, j, SymbolExtended.CaseTeasingNormal)) {
    //                         const currentCaseType = symbol.getCurrentCase();
    //
    //                         if (SymbolExtended.CaseTeasingNormal !== currentCaseType) {
    //                             symbol.goToCase(SymbolExtended.CaseTeasingNormal);
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }

    onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number) {
        super.onReelStopped(reelsData, reelIndex);

        // if(ReelExtended.TeaseIndex === this.reelCount-1 && reelIndex === this.reelCount-2) {
        //     this.symbolsGoToTeasing(this.reelCount-1, false);
        // }

        if (ReelExtended.Tease) {
            for (let i = 0; i < this.currentSymbols.length - 1; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    const symbol = this.currentSymbols[i][j];
                    // if (symbol !== null && symbol.id !== Settings.SymbolTeasing - 1) {
                    if (symbol != null && j != 1) {
                        symbol.goToCase(Symbol.CaseNowin);
                    }
                }
            }

            if (reelIndex == this.reelCount - 1) {
                for (let i = 0; i < this.currentSymbols.length - 1; i++) {
                    for (let j = 0; j < this.currentSymbols[i].length; j++) {
                        const symbol = this.currentSymbols[i][j];
                        // if (symbol !== null && symbol.id !== Settings.SymbolTeasing - 1) {
                        if (symbol != null && j != 1) {
                            symbol.goToCase(Symbol.CaseNormal);
                        }
                    }
                }
            }
        }

        if (this.currentSymbols[reelIndex]) {
            this.currentSymbols[reelIndex].forEach((symbol, symbolIndex) => {
                if (
                    ReelExtended.Tease &&
                    symbol.hasCase("IMPACT_TEASE") &&
                    symbolIndex != 1 &&
                    reelIndex != this.reelCount - 1
                ) {
                    symbol.goToCase("IMPACT_TEASE");
                } else if (symbol.hasCase("IMPACT")) {
                    symbol.goToCase("IMPACT");
                }
            });
        }
        this.sortSymbols();
    }

    //******************************************************************************************************************
    //  WINS
    //******************************************************************************************************************

    showWins(wins: Array<Communication.Game.IWin>, win: number): boolean {
        let ret = super.showWins(wins, win);
        let middleLineWin = wins.filter((win) => win.type == Communication.Game.WinType.freeSpins).length > 0;
        if (win > 0) {
            this._paylines.visible = true;

            if (this.currentMultiplierIndex > 1) {
                // priority: HIGH + number -> HIGH -> WIN
                this.setActiveElementCaseArray([
                    WinAnimatorExtended.CaseHighWin + this.currentMultiplierIndex,
                    WinAnimatorExtended.CaseHighWin,
                    middleLineWin ? WinAnimatorExtended.CaseMiddleLineWin : WinAnimatorExtended.CaseWin,
                ]);
            } else {
                // priority: WIN
                this.setActiveElementCaseArray([
                    middleLineWin ? WinAnimatorExtended.CaseMiddleLineWin : WinAnimatorExtended.CaseWin,
                ]);
            }
        } else {
            // priority: NOWIN
            this.setActiveElementCaseArray([WinAnimatorExtended.CaseNoWin]);
        }

        return ret;
    }

    protected showFirstWins(): void {
        if (this.currentWin === BetManager.Bet) {
            super.showFirstWins();
        } else if (this.currentMultiplierIndex < 2) {
            this.currentCounterStep = 0;

            this.startTimer(WinAnimatorExtended.ShowFirstWinsStep, 15);
        } else {
            super.showFirstWins();
        }
    }

    protected showFirstWinsStep(): void {
        // PlayList.stop("SND_BaseLoop", 10);
        // PlayList.stop("SND_FSLoop", 10);

        const win = this.currentWins[this.currentCounterStep];

        if (!win) {
            this.currentCounterStep--;
            this.startTimer(WinAnimatorExtended.FinishWin, 0);
            return;
        }

        if (win.type != Communication.Game.WinType.Cash) {
            this.currentCounterStep++;
            this.showFirstWinsStep();

            return;
        }

        this.allPaylinesGoToCase(Payline.CaseNowin);
        this.allSymbolsGoToCase(Symbol.CaseNowin, true);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winPaylineGoToCase(i, Payline.CaseNormal);
            this.winSymbolsGoToCase(i, Symbol.CaseNormal, false);
        }

        this.winPaylineGoToCase(this.currentCounterStep, Payline.CaseWin);
        const symbols = this.winSymbolsGoToCase(this.currentCounterStep, Symbol.CaseWin, false);

        this.runCounterStep();

        this.currentCounterStep++;

        if (this.currentWin / BetManager.Bet > 1) {
            this.startTimer(
                this.currentCounterStep < this.currentWins.length
                    ? WinAnimatorExtended.ShowFirstWinsStep
                    : WinAnimatorExtended.FinishWin,
                this._paylineWinDelay,
            );
        } else {
            this.startTimer(
                this.currentCounterStep < this.currentWins.length
                    ? WinAnimatorExtended.ShowFirstWinsStep
                    : WinAnimatorExtended.FinishWin,
                0,
            );
        }
    }

    private getCounterStep(): number {
        return (0.8 - 0.5) / this.currentWins.length + 0.01;
    }

    protected runCounterStep(): void {
        this._counter.visible = true;
        this._flare.visible = true;

        PlayList.play("SND_BaseWinCounterStep" + Math.min(this.currentCounterStep + 1, 18));

        let amountFrom = "0";
        let amountTo = "0";

        for (let i = 0; i <= this.currentCounterStep; i++) {
            const win = this.currentWins[i];

            if (win.type === Communication.Game.WinType.Cash) {
                if (i < this.currentCounterStep) {
                    amountFrom = NumberUtils.add(amountFrom, this.currentWins[i].amount);
                }

                amountTo = NumberUtils.add(amountTo, this.currentWins[i].amount);
            }
        }

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            this._counter.start(
                parseInt(NumberUtils.devide(amountFrom, BetManager.CoinSize).toString()),
                parseInt(NumberUtils.devide(amountTo, BetManager.CoinSize).toString()),
                0,
            );
        } else {
            ImageTextCounterElement.Round = false;
            this._counter.start(parseFloat(amountFrom), parseFloat(amountTo), 0);
        }

        const step = this.getCounterStep();

        Tweens.removeTweens(this._counter, "all");
        Tweens.removeTweens(this._flare, "all");
        Tweens.alphaTween(this._counter, {
            alphas: [this._counter.alpha, 1],
            tweenDuration: 20,
        });
        Tweens.alphaTween(this._flare, {
            alphas: [this._flare.alpha, 0.8],
            tweenDuration: 20,
        });

        Tweens.scaleTween(this._counter, {
            tweenValues: [
                new PIXI.Point(0.7 + step * this.currentCounterStep, 0.7 + step * this.currentCounterStep),
                new PIXI.Point(
                    0.75 + step * (this.currentCounterStep + 1),
                    0.75 + step * (this.currentCounterStep + 1),
                ),
                new PIXI.Point(
                    0.75 + step * (this.currentCounterStep + 1),
                    0.75 + step * (this.currentCounterStep + 1),
                ),
                new PIXI.Point(
                    0.75 + step * (this.currentCounterStep + 1),
                    0.75 + step * (this.currentCounterStep + 1),
                ),
                new PIXI.Point(0.7 + step * (this.currentCounterStep + 1), 0.7 + step * (this.currentCounterStep + 1)),
            ],
            tweenDuration: 40,
            tweenEase: "backInOut",
        });
        Tweens.scaleTween(this._flare, {
            tweenValues: [
                new PIXI.Point(0.7 + step * this.currentCounterStep, 0.7 + step * this.currentCounterStep),
                new PIXI.Point(
                    0.75 + step * (this.currentCounterStep + 1),
                    0.75 + step * (this.currentCounterStep + 1),
                ),
                new PIXI.Point(
                    0.75 + step * (this.currentCounterStep + 1),
                    0.75 + step * (this.currentCounterStep + 1),
                ),
                new PIXI.Point(
                    0.75 + step * (this.currentCounterStep + 1),
                    0.75 + step * (this.currentCounterStep + 1),
                ),
                new PIXI.Point(0.7 + step * (this.currentCounterStep + 1), 0.7 + step * (this.currentCounterStep + 1)),
            ],
            tweenDuration: 40,
            tweenEase: "backInOut",
        });
    }

    protected runCounterOutro(reset: boolean = false): void {
        if (this.currentMultiplierIndex > 1 || this.currentWin === undefined || this.currentWin === null) {
            return;
        }

        // this.counter.glowAsWin();

        if (AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null) {
            ImageTextCounterElement.Round = true;
            this._counter.start(0, parseInt(NumberUtils.devide(this.currentWin, BetManager.CoinSize).toString()), 0);
        } else {
            ImageTextCounterElement.Round = false;
            this._counter.start(0, this.currentWin, 0);
        }

        let counterSize = 0.7 + this.getCounterStep() * (reset ? this.currentWins.length : this.currentCounterStep);

        let finish = (reset: boolean = false) => {
            if (reset) {
                PlayList.play("SND_BaseWinCounterFinal");

                Tweens.scaleTween(this._counter, {
                    tweenValues: [
                        new PIXI.Point(counterSize, counterSize),
                        new PIXI.Point(counterSize + 0.2, counterSize + 0.2),
                        new PIXI.Point(counterSize, counterSize),
                    ],
                    tweenDuration: 15,
                    tweenDelay: 0,
                });

                Tweens.scaleTween(this._flare, {
                    tweenValues: [
                        new PIXI.Point(counterSize, counterSize),
                        new PIXI.Point(counterSize + 0.2, counterSize + 0.2),
                        new PIXI.Point(counterSize, counterSize),
                    ],
                    tweenDuration: 15,
                    tweenDelay: 0,
                });
            }

            Tweens.alphaTween(this._counter, {
                alphas: [1, 0],
                tweenDuration: 20,
                tweenDelay: 30,
                callbackFunction: (params) => {
                    if (reset) {
                        // PlayList.play('SND_BaseWinCounterFinal');
                    }

                    PlayList.play("SND_BaseWinAway");
                },
                callbackType: "onStart",
            });
            Tweens.alphaTween(this._flare, {
                alphas: [0.8, 0],
                tweenDuration: 20,
                tweenDelay: 30,
            });
            Tweens.scaleTween(this._flare, {
                tweenValues: [
                    new PIXI.Point(counterSize, counterSize),
                    new PIXI.Point(counterSize + 1, counterSize + 1),
                ],
                tweenDuration: 20,
                tweenDelay: 30,
                callbackType: "onComplete",
            });
            Tweens.scaleTween(this._counter, {
                tweenValues: [
                    new PIXI.Point(counterSize, counterSize),
                    new PIXI.Point(counterSize + 1, counterSize + 1),
                ],
                tweenDuration: 20,
                tweenDelay: 30,
                callbackFunction: (params) => {
                    this._counter.visible = false;
                    this._flare.visible = false;

                    let response = GameManager.baseResponse;
                    if (ModuleManager.freespinsActive()) {
                        response = GameManager.freespinsResponse;
                    }
                    if (
                        response &&
                        response.wins &&
                        response.wins.filter((w) => w.type == Communication.Game.WinType.freeSpins).length > 0
                    ) {
                        this.setActiveElementCaseArray(["FS_WIN"]);

                        for (var i = 0; i < response.wins.length; i++) {
                            if (response.wins[i].type == Communication.Game.WinType.freeSpins) {
                                this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
                                break;
                            }
                        }
                    }
                },
                callbackType: "onComplete",
            });
        };

        Tweens.removeTweens(this._counter, "all");
        Tweens.removeTweens(this._flare, "all");
        if (reset) {
            finish(true);
        } else {
            if (this.currentWin / BetManager.Bet <= 1) {
                Tweens.scaleTween(this._flare, {
                    tweenValues: [new PIXI.Point(counterSize, counterSize), new PIXI.Point(counterSize, counterSize)],
                    tweenDuration: 20,
                    tweenDelay: 0,
                });
                Tweens.scaleTween(this._counter, {
                    tweenValues: [new PIXI.Point(counterSize, counterSize), new PIXI.Point(counterSize, counterSize)],
                    tweenDuration: 20,
                    tweenDelay: 0,
                    callbackFunction: finish,
                });
            } else {
                Tweens.scaleTween(this._flare, {
                    tweenValues: [
                        new PIXI.Point(counterSize, counterSize),
                        new PIXI.Point(counterSize + 0.2, counterSize + 0.2),
                        new PIXI.Point(counterSize, counterSize),
                    ],
                    tweenDuration: 15,
                    tweenDelay: 20,
                });
                Tweens.scaleTween(this._counter, {
                    tweenValues: [
                        new PIXI.Point(counterSize, counterSize),
                        new PIXI.Point(counterSize + 0.2, counterSize + 0.2),
                        new PIXI.Point(counterSize, counterSize),
                    ],
                    tweenDuration: 15,
                    tweenDelay: 20,
                    callbackFunction: finish,
                });
            }
            Tweens.alphaTween(this._counter, {
                alphas: [this._counter.alpha, 1],
                tweenDuration: 5,
                tweenDelay: 0,
                callbackFunction: (params) => {
                    PlayList.play("SND_BaseWinCounterFinal");
                },
                callbackType: "onStart",
            });
            Tweens.alphaTween(this._flare, {
                alphas: [this._flare.alpha, 0.8],
                tweenDuration: 5,
                tweenDelay: 0,
            });
        }
    }

    protected winSymbolsGoToCaseAsCustom(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        for (let i = 0; i < this.reelCount; i++) {
            const symbol = this.currentSymbols[i][1];
            symbol.goToCase(caseType);

            this.symbolsContainer.addChild(symbol);

            symbols.push(symbol);
        }

        return symbols;
    }

    onTimerComplete(): void {
        this.timer.stop();

        switch (this.timerStatus) {
            case WinAnimatorExtended.ShowFirstWinsStep:
                this.showFirstWinsStep();
                break;
            case WinAnimatorExtended.EndFirstWinsStep:
                this.emit(WinAnimator.FinishWinAnimator);
                this.currentCycle = 0;
                this.cycleWins(true);
                break;
            case WinAnimatorExtended.FinishWin:
                this.finishWin();
                break;
            default:
                super.onTimerComplete();
                break;
        }
    }

    protected finishWin(): void {
        this.emit(WinAnimator.FinishWinCalculation);

        this.runCounterOutro();

        this.startTimer(WinAnimatorExtended.EndFirstWinsStep, this._paylineWinEndDelay);
    }

    protected showCustomWin(): boolean {
        let response = GameManager.baseResponse;
        if (ModuleManager.freespinsActive()) {
            response = GameManager.freespinsResponse;
        }

        if (response.gameMultiplier > 1) {
            this._doubleWin.goToCase("PLAY");
            this._doubleWin.once("finishAnimation", () => {
                this.showFirstWins();
            });

            return true;
        }

        return false;
    }

    protected finishFirstWins() {
        super.finishFirstWins();
        let response = GameManager.baseResponse;
        if (ModuleManager.freespinsActive()) {
            response = GameManager.freespinsResponse;
        }
        if (response.wins && response.wins.filter((w) => w.type == Communication.Game.WinType.freeSpins).length > 0) {
            this.setActiveElementCaseArray(["FS_WIN"]);

            for (var i = 0; i < response.wins.length; i++) {
                if (response.wins[i].type == Communication.Game.WinType.freeSpins) {
                    this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
                    break;
                }
            }
        }
    }

    // private counterWins(index : number = 0, sum : number = 0) {
    //     // let animation = this.animations[this.getAnimationIndex()];
    //
    //     if (index == this.currentWins.length) {
    //         this.onAnimationComplete();
    //         return;
    //     }
    //
    //     // animation.visible = true;
    //
    //     let win = this.currentWins[index];
    //
    //     this.winSymbolsGoToCase(index, Symbol.CaseWin, false);
    //     this.winPaylineGoToCase(index, Payline.CaseWin);
    //
    //     this._counter.start(sum + win.amount, sum + win.amount);
    //     this._counter.visible = true;
    //     this._counter.alpha = 1;
    //     // animation.play(sum + win.amount);
    //
    //     // Tweens.removeTweens(this._counter, 'all');
    //     // Tweens.alphaTween(this._counter, {
    //     //     alphas: [this._counter.alpha, 1],
    //     //     tweenDuration: 20
    //     // });
    //
    //     Tweens.scaleTween(this._counter, {
    //         tweenValues: [
    //             new PIXI.Point(0.5 + (index * 0.3 / (this.currentWins.length + 1)), 0.5 + (index * 0.3 / (this.currentWins.length + 1))),
    //             new PIXI.Point(0.55 + (index * 0.3 / (this.currentWins.length + 1)), 0.55 + (index * 0.3 / (this.currentWins.length + 1))),
    //             new PIXI.Point(0.55 + (index * 0.3 / (this.currentWins.length + 1)), 0.55 + (index * 0.3 / (this.currentWins.length + 1))),
    //             new PIXI.Point(0.55 + (index * 0.3 / (this.currentWins.length + 1)), 0.55 + (index * 0.3 / (this.currentWins.length + 1))),
    //             new PIXI.Point(0.5 + (index * 0.3 / (this.currentWins.length + 1)), 0.5 + (index * 0.3 / (this.currentWins.length + 1)))
    //         ],
    //         tweenDuration: 55,
    //         tweenEase: 'backInOut'
    //     });
    //
    //     this._counterTimer.start(60, ++index, sum + win.amount);
    // }
    //
    // private counterOutro(reset : boolean = false) {
    //     if (this.currentWins && this.currentWins.length > 0) {
    //
    //         Tweens.removeTweens(this._counter, 'all');
    //
    //         this._counter.start(this.currentWin, this.currentWin);
    //
    //         Tweens.alphaTween(this._counter, {
    //             alphas: [1, 0],
    //             tweenDuration: 20,
    //             tweenDelay: 20,
    //             // callbackFunction: params => {
    //             //     if (reset) {
    //             //         PlayList.stop('SND_BaseWinFinal');
    //             //     }
    //             //     PlayList.play('SND_BaseWinAway');
    //             // },
    //             // callbackType: 'onStart'
    //         });
    //         Tweens.scaleTween(this._counter, {
    //             tweenValues: [
    //                 new PIXI.Point(0.5 + ((this.currentWins.length - 1) * 0.3 / (this.currentWins.length + 1)), 0.5 + ((this.currentWins.length - 1) * 0.3 / (this.currentWins.length + 1))),
    //                 new PIXI.Point(0.5 + ((this.currentWins.length - 1) * 0.3 / (this.currentWins.length + 1)) + 1, 0.5 + ((this.currentWins.length - 1) * 0.3 / (this.currentWins.length + 1)) + 1)
    //             ],
    //             tweenDuration: 20,
    //             tweenDelay: 20,
    //             callbackType: "onComplete",
    //             callbackFunction: () => {
    //                 if (!reset) {
    //                     super.onAnimationComplete();
    //                 }
    //             }
    //         });
    //     }
    // }

    // protected onAnimationComplete() {
    //     if (this.getAnimationIndex() < 2) {
    //         this._counterFinished = true;
    //         this.counterOutro();
    //     } else {
    //         super.onAnimationComplete();
    //     }
    // }

    //******************************************************************************************************************
    //  RESET
    //******************************************************************************************************************

    public reset(showLastSymbols: boolean, spin = false): boolean {
        this._paylines.visible = false;

        // if (!this._counterFinished) {
        //     this.counterOutro(true);
        // }
        //
        // this._counterTimer.stop();

        switch (this.timerStatus) {
            case WinAnimatorExtended.ShowFirstWinsStep:
                this.runCounterOutro(true);
                break;
            case WinAnimatorExtended.FinishWin:
                this.runCounterOutro(true);
                this.currentCounterStep = null;
                this.timerStatus = null;
                this.currentCycle = 0;
                break;
            case WinAnimatorExtended.EndFirstWinsStep:
                this.currentCounterStep = null;
                this.timerStatus = null;
                this.currentCycle = 0;
                break;
        }

        this.setActiveElementCaseArray([WinAnimatorExtended.CaseNormal]);

        return super.reset(showLastSymbols, spin);
    }

    //******************************************************************************************************************
    //  ACTIVE ELEMENTS
    //******************************************************************************************************************

    /**
     * Attempts to switch all Active Elements to the earliest case from array the element can be switched to.
     * Elements with no case from the list are ignored.
     * @param s Array of names of cases to try to switch to
     * @param emitEvent
     * @param delay Switch delay
     */
    public setActiveElementCaseArray(s: Array<string>, emitEvent: boolean = false, delay?: number) {
        if (!s.length) {
            return;
        }
        if (!this.visible) {
            return;
        }
        this._activeElementsCase = s[0];
        this._activeElements.forEach((element) => {
            for (let i = 0; i < s.length; i++) {
                if (element.hasCase(s[i])) {
                    element.goToCase(s[i], emitEvent, delay);
                    break;
                }
            }
        });
    }

    /**
     * Attempts to switch all Active Elements to the given case if they have this case.
     * Elements without the case are ignored.
     * @param s Case name
     * @param emitEvent
     * @param delay
     */
    private setActiveElementCase(s: string, emitEvent: boolean = false, delay?: number) {
        if (!this.visible) {
            return;
        }

        this._activeElementsCase = s;
        this._activeElements.forEach((element) => {
            if (element.hasCase(s)) {
                element.goToCase(s, emitEvent, delay);
            }
        });
    }

    /**
     * Returns last case switched to, or the first case from a list switched to.
     */
    private getActiveElementCase(): string {
        return this._activeElementsCase;
    }

    protected cycleWins(isFirst: boolean = false) {
        if (
            ModuleManager.freespinsEnabled() ||
            (ModuleManager.freespinsActive() && this.isLastFreespin()) ||
            this.hasFreespinWin()
        ) {
            return;
        }

        if (DataManager.Autoplay == false) {
            PlayList.setVolume("SND_BaseLoop", 0);
        }
        if (!ModuleManager.freespinsEnabled() && !ModuleManager.freespinsActive()) {
            PlayList.setVolume("SND_FSLoop", 0);
        }

        super.cycleWins(isFirst);
    }

    private isLastFreespin(): boolean {
        if (DataManager.GameLimit) {
            return true;
        }

        return (
            GameManager.freespinsResponse.freeSpins != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount != null &&
            GameManager.freespinsResponse.freeSpins.remainingCount === 0
        );
    }
    private hasFreespinWin(): boolean {
        let response = GameManager.baseResponse;
        if (ModuleManager.freespinsActive()) {
            response = GameManager.freespinsResponse;
        }

        return response.wins && response.wins.filter((w) => w.type == Communication.Game.WinType.freeSpins).length > 0;
    }

    public calculationCounter(actualCounterValue: string): void {
        console.log("....calc:..." + actualCounterValue);

        if (
            actualCounterValue == null ||
            actualCounterValue == "" ||
            this._bgWinsIndex == null ||
            this._bgScaleX === 0 ||
            this._bgScaleXMul === 0 ||
            this._bgElementName == null
        ) {
            return;
        }

        let counterLength: number = actualCounterValue.length;
        let aniIndex: number = this.getAnimationIndex();

        if (this._bgWinsIndex.indexOf(aniIndex) === -1 || aniIndex == null) {
            return;
        }

        let elements: ContainerElement = this.animations[aniIndex].getElements();

        if (counterLength > 0 && elements) {
            // let bgElementPath = this._bgElementName.split('.');
            // for (let i = 0; i < bgElementPath.length; i++) {
            //     let tmpEl = elements.getChildElementByName(bgElementPath[i]);
            //     if (tmpEl) {
            //         elements = <ContainerElement>tmpEl;
            //     } else {
            //         break;
            //     }
            // }
            let conBg = elements.getChildElementByName("ConBg");
            if (conBg) {
                let middle = <ContainerElement>(<ContainerElement>conBg).getChildElementByName("Middle");

                if (middle && middle instanceof PIXI.Sprite) {
                    if (this._bgScaleXRankTo == 0 || this._bgScaleXRankTo < this._bgScaleXRankFrom) {
                        this._bgScaleXRankTo = counterLength;
                    }

                    if (counterLength <= this._bgScaleXRankFrom) {
                        // reset to default scale
                        middle.scale.x = this._bgScaleX;
                        // left.position.x = (middle.pivot.x * (this._bgScaleX - 1)) * -1;
                        // right.position.x = middle.pivot.x * (this._bgScaleX - 1);
                    } else if (counterLength <= this._bgScaleXRankTo) {
                        let newScaleX: number =
                            this._bgScaleX + (counterLength - this._bgScaleXRankFrom) * this._bgScaleXMul; // basic scale + (add scale * rank)
                        (<PIXI.Sprite>middle).scale.x = newScaleX;
                        // left.position.x = (middle.pivot.x * (newScaleX - 1)) * -1;
                        // right.position.x = middle.pivot.x * (newScaleX - 1);

                        // console.log(newScaleX);
                        // console.log(middle.width);
                        // console.log(left.position);

                        //console.log(".......newScaleX: " + newScaleX);
                    } else {
                        let newScaleX: number =
                            this._bgScaleX + (this._bgScaleXRankTo - this._bgScaleXRankFrom) * this._bgScaleXMul; // basic scale + (add scale * rank)
                        (<PIXI.Sprite>middle).scale.x = newScaleX;
                        // left.position.x = (middle.pivot.x * (newScaleX - 1)) * -1;
                        // right.position.x = middle.pivot.x * (newScaleX - 1);
                    }
                }
            }
        }
    }
}

export const WinAnimatorExtendedAttributes = {
    CYCLE_ANIMATION: "CycleAnimation",
    ACTIVE_ELEMENTS: "ActiveElements",

    /**
     * Dynamic scale for win counter.
     * BgElementName - name of scale element (tween object: ContainerElement...)
     * BgWinsIndex - indexes of all accepted wins (which wins will be scaling)
     * BgScaleX - base (start) scale of element
     * BgScaleXMultiplier - multiplication of rank scaleX by one step
     * BgRankFrom - start scale rank of counter
     * BgRankTo - end scale rank of counter
     * @property SymbolToWildTimeY
     * @type number
     * @default 1
     */
    BG_ELEMENT_NAME: "BgElementName",
    BG_WINS_INDEX: "BgWinsIndex",
    BG_SCALE_X: "BgScaleX",
    BG_SCALE_X_MULTIPLIER: "BgScaleXMultiplier",
    BG_RANK_FROM: "BgRankFrom",
    BG_RANK_TO: "BgRankTo",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorExtended.ts
 **/